import Search from 'src/shared/ui/Search/Search';
import styled from 'styled-components';

export const VariableStyledSearch = styled(Search)`
  margin-bottom: 16px;
`;
